import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { RequestForm } from "./components/RequestForm/RequestForm";
import { Documentation } from "./components/Documentation/Documentation";
import { Header } from "./components/shared/Header";

export function App() {
  return (
    <div>
      <Router>
        <Header />
        <Routes>
          <Route
            exact
            path="/"
            element={<RequestForm />}
          />
          <Route
            exact
            path="/RequestForm"
            element={<RequestForm />}
          />
          <Route
            path="/Documentation"
            element={<Documentation />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
